// extracted by mini-css-extract-plugin
export default {"buttons-container":"styles_buttons-container__GtVoY","button-left":"styles_button-left__RoCnb","button-right":"styles_button-right__3AzC2"};